import { api } from "../api";

/**
 * inactivateInterestPointCrudRequest - Function that inactivates an interest point
 * /interest-points/{customerId}/{interestPointId}/{status}
 * method PUT
 * @async-function
 */
const inactivateInterestPointCrudRequest = async (
    token: string,
    customerId: number,
    interestPointId: number
) => {
    const response = await api.put(
        `/interest-points/${customerId}/${interestPointId}/deactivated`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default inactivateInterestPointCrudRequest;
